export default __webpack_public_path__ + "static/photo_creative_people_planning-2362cec662d07e94c22f8982b4ddf6eb.jpg";